module.exports = __webpack_public_path__ + "static/media/bg3.4bff5d45.jpg";